module.exports = __webpack_public_path__ + "img/5f4f667.jpg";